
import StraightQuotes from "./StraightQuotes.webp";
import CioReview from "./cio-review.webp";
import Clutch from "./clutch.webp";
import Cmmi from "./cmmi.webp";
import sdk_1 from "./sdk_1.webp";
import sdk_2 from "./sdk_2.webp";
import sdk_3 from "./sdk_3.webp";
import sdk_4 from "./sdk_4.webp";
import TanThetaChart from "./TanThetaChart.webp";
import TanThetaChartMobile from "./TanThetaChartMobile.webp";
import HandDrawnNftStyleApeIllustration from "./hand-drawn-nft-style-ape-illustration.webp";
import Emc2 from "./Innovation/Emc22.webp";
import ReactLogo from "./Innovation/ReactLogo.webp";
import SkilledTechniqueImage from "./Innovation/skilledTech.webp";
import DefiniteProcessImage from "./Innovation/definiteProccess.webp";
import UnmatchedTransparencyImage from "./Innovation/unmatchedTrans.webp";
import DraftKings from "./Marquees/DraftKings.webp";
import Zapper from "./Marquees/Zapper.webp";
import Rainbow from "./Marquees/Rainbow.webp";
import Royal from "./Marquees/Royal.webp";
import Gamestop from "./Marquees/Gamestop.webp";
import Ledger from "./Marquees/Ledger.webp";
import Chainlink from "./Marquees/Chainlink.webp";
import ElementFI from "./Marquees/ElementFI.webp";
import Circle from "./Marquees/Circle.webp";
import Chainpass from "./Marquees/Chainpass.webp";
import Illuvium from "./Marquees/Illuvium.webp";
import RightSIdeArrow from "./right-arrow.webp";
import Ethereum from "./ethereum-icon.webp";
import Polygon from "./Polygon.webp";
import MaskGroup from "./maskGroup.webp";
import MaskGroup1 from "./maskGroup1.webp";
import ClientReviews1 from "./ClientReviews1.webp";
import ClientReviews2 from "./ClientReviews2.webp";


export {
  StraightQuotes,
  CioReview,
  Clutch,
  Cmmi,
  sdk_1,
  sdk_2,
  sdk_3,
  sdk_4,
  TanThetaChart,
  TanThetaChartMobile,
  HandDrawnNftStyleApeIllustration,
  Emc2,
  ReactLogo,
  SkilledTechniqueImage,
  DefiniteProcessImage,
  UnmatchedTransparencyImage,
  DraftKings,
  Zapper,
  Rainbow,
  Royal,
  Gamestop,
  Ledger,
  Chainlink,
  ElementFI,
  Circle,
  Chainpass,
  Illuvium,
  RightSIdeArrow,
  Ethereum,
  Polygon,
  MaskGroup,
  MaskGroup1,
  ClientReviews1,
  ClientReviews2,
};
